<script setup>
import { ref } from "vue";

const props = defineProps({
  shortcodes: {
    type: Object,
    required: true, // { url: '...', name: '...' }
  },
  bottom: {
    type: Number,
    default: 100, // px
  },
});

// "url" | "name" | null
const copiedType = ref(null);

async function copyToClipboard(type) {
  try {
    const value =
        type === "url"
            ? props.shortcodes?.url
            : props.shortcodes?.name;

    if (!value) {
      console.warn("Shortcode is missing:", type);
      return;
    }

    await navigator.clipboard.writeText(value);
    copiedType.value = type;

    setTimeout(() => {
      if (copiedType.value === type) {
        copiedType.value = null;
      }
    }, 1200);

  } catch (e) {
    console.error("Clipboard error:", e);
  }
}
</script>

<template>
  <div
      class="adm-info"
      :style="{ bottom: bottom + 'px' }"
  >
    <!-- URL кнопка -->
    <div class="adm-btn" @click="copyToClipboard('url')">
      <span v-if="copiedType !== 'url'">Copy URL</span>
      <span v-else>Copied</span>
    </div>

    <!-- NAME кнопка -->
    <div class="adm-btn" @click="copyToClipboard('name')">
      <span v-if="copiedType !== 'name'">Copy Name</span>
      <span v-else>Copied</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.adm-info {
  position: fixed;
  right: 36px;
  z-index: 9;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: normal;
}

.adm-btn {
  width: auto;
  padding: 0 14px;
  height: 42px;
  color: #fff;
  background: #fcc000;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-radius: 6px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, .08);
  cursor: pointer;
  z-index: 999999999999999;
  transition: all .2s ease;
}
</style>
